<main id="main-content" tabindex="-1" aria-label="Account Settings">
  <div class="mt-10 px-20">
    <prism-title title="Account Settings"></prism-title>

    <div role="tablist" aria-label="Account settings sections" class=" flex items-end border-b border-gray-300 mt-10 mb-6">
      <button
        *ngFor="let t of tabs; let i = index"
        #tabHeader
        type="button"
        role="tab"
        [id]="'as-tab-' + i"
        [attr.aria-selected]="selectedIndex === i"
        [attr.aria-controls]="'as-panel-' + i"
        [attr.tabindex]="selectedIndex === i ? 0 : -1"
        (click)="setSelected(i)"
        (keydown)="onHeaderKey($event, i)"
        class="px-4 py-2 rounded-t-xl border-2 border-b-4 font-semibold outline-none hover:bg-gray-100 focus-visible:ring-2 focus-visible:ring-offset-2"
        [class.bg-dark-purple]="selectedIndex === i"
        [class.text-white]="selectedIndex === i"
        [class.border-dark-purple]="selectedIndex === i"
        [class.bg-white]="selectedIndex !== i"
        [class.text-dark-purple]="selectedIndex !== i"
        [class.border-gray-300]="selectedIndex !== i"
      >
        {{ t }}
      </button>
      <div class="flex-1 h-0.5 bg-gray-300 ml-2"></div>

    </div>


    @if (selectedIndex === 0) {
      <section
        role="tabpanel"
        class="outline-none"
        [id]="'as-panel-0'"
        [attr.aria-labelledby]="'as-tab-0'"
        tabindex="0"
      >
        <form
          [formGroup]="settingsForm"
          class="grid lg:grid-cols-2 gap-x-6 gap-y-4 mb-4"
          (submit)="saveChanges()"
        >
          <div class="col-span-2 lg:col-span-1">
            <prism-input
              [control]="firstName"
              label="First Name"
              [required]="true"
              [maxLength]="50"
            >
            </prism-input>
          </div>

          <div class="col-span-2 lg:col-span-1">
            <prism-input
              [control]="lastName"
              label="Last Name"
              [required]="true"
              [maxLength]="50"
            >
            </prism-input>
          </div>

          <div class="col-span-2 lg:col-span-1">
            <prism-input
              [control]="emailName"
              label="Email Address"
              inputType="email"
              [readOnly]="!isEditable"
              [required]="true"
            >
            </prism-input>
          </div>

          @if (!isSuperAdmin) {
            <div class="col-span-2 lg:col-span-1">
              <prism-select-organization
                [control]="districtIds"
                label="District"
                [required]="true"
                [readOnly]="true"
                [multiSelect]="isDistrictAdmin"
              >
              </prism-select-organization>
            </div>
          }

          @if (isUser) {
            <div class="col-span-2 lg:col-span-1">
              <prism-select-school
                    [control]="schoolId"
                    [districtId]="districtIds?.value"
                    label="School"
                    [required]="true"
                    [readOnly]="true">
              </prism-select-school>
            </div>

            <div class="col-span-2 lg:col-span-1">
              <prism-select-grade
                [control]="gradeIds"
                label="Grade Level"
                [required]="true"
                [readOnly]="true"
                [multiSelect]="true"
              >
              </prism-select-grade>
            </div>
          }

          <div class="col-span-2 md:flex md:justify-start mt-4">
            <prism-btn
              btnClass="btn-purple"
              [disabled]="settingsForm.pristine || !settingsForm.valid"
            >
              Submit
            </prism-btn>
          </div>
        </form>
      </section>
    }

    @if (selectedIndex === 1) {
      <section role="tabpanel" class="outline-none" [id]="'as-panel-1'" [attr.aria-labelledby]="'as-tab-1'" tabindex="0">
        <form [formGroup]="bannerTableForm" (ngSubmit)="saveBannerRow()">

          <div class="relative overflow-x-auto">
            <table
              class="w-full min-w-[64rem] table-fixed text-left"
              role="table"
              aria-label="Site settings"
            >
              <colgroup>
                <col class="md:w-2/5" />
                <col class="md:w-2/5" />
                <col class="md:w-[10%] w-[96px]" />
                <col class="md:w-[10%] w-[112px]" />
              </colgroup>

              <thead>
                <tr>
                  <th scope="col" class="px-4 pb-2 text-xs sm:text-sm font-semibold text-dark-purple">Setting</th>
                  <th scope="col" class="px-4 pb-2 text-xs sm:text-sm font-semibold text-dark-purple">Message</th>
                  <th scope="col" class="px-4 pb-2 text-xs sm:text-sm font-semibold text-dark-purple text-center">Enabled</th>
                  <th scope="col" class="px-4 pb-2"><span class="sr-only">Actions</span></th> 
                </tr>
              </thead>

              <tbody>
                <tr class="bg-light-purple border-y-8 border-white">

                  <td class="py-2 px-5 text-xs sm:text-sm text-dark-purple font-semibold align-middle min-w-[20rem]">
                    Shows a banner to logged in users that the website is currently being updated.
                  </td>

                  <td class="py-2 px-5 align-middle min-w-[28rem]">
                     <label for="banner-message" class="sr-only">Your Message:</label>
                    <textarea
                      id="banner-message"
                      formControlName="message"
                      name="banner-message"
                      rows="2"
                      class="w-full border rounded p-2"
                      required
                      [attr.maxlength]="500"
                      placeholder="Type a message…">
                    </textarea>

                    <div id="message-counter"
                        class="ml-auto text-xs"
                        [class.text-red-600]="(500 - (messageCtrl?.value?.length || 0)) === 0">
                      {{ 500 - (messageCtrl?.value?.length || 0) }} characters left
                    </div>
                  </td>

                  <td class="py-2 px-5 align-middle text-center min-w-[6rem]">
                    <label class="inline-flex items-center justify-center">
                      <input type="checkbox" formControlName="isActive" name="banner-isActive" class="h-5 w-5" />
                      <span class="sr-only">Show banner</span>
                    </label>
                  </td>

                  <td class="py-2 px-5 align-middle text-right min-w-[8rem]">
                    <div class="flex sm:justify-end">
                      <button
                        type="submit"
                        class="btn-purple inline-flex items-center justify-center
                              px-4 py-2 w-full sm:w-auto min-w-[6rem] shrink-0 whitespace-nowrap"
                        [disabled]="messageCtrl?.invalid">
                        Save
                      </button>
                    </div>
                  </td>

                </tr>
              </tbody>
            </table>
          </div>
        </form>
      </section>
    }
  </div>
</main>
